import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getMonthlyHistory({ commit }, dateObject) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/reports/monthly/" + dateObject.id,
            method: "POST",
            data: { date: dateObject.date }
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMonthlyReports({ commit }, dateObject) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/reports/monthly",
            method: "POST",
            data: { date: dateObject.date, employees: dateObject.employees }
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getTimespanHistory({ commit }, requestObject) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/reports/timespan/" + requestObject.id,
            method: "POST",
            data: {
              employees: requestObject.employees,
              fromDate: requestObject.fromDate,
              toDate: requestObject.toDate
            }
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
  modules: {},
  getters: {}
};
